import SocialShare from './SocialShare';
import PropTypes from 'prop-types';
import DateInfo from '../../DateInfo';

const Body = (props) => {
  const { properties, data } = props;
  const { hideSocialShare } = data;

  return (
    <div className="document-byline">
      <DateInfo properties={properties} />
      {hideSocialShare ? null : (
        <SocialShare url={properties['@id']} text={properties.title} />
      )}
    </div>
  );
};

Body.propTypes = {
  properties: PropTypes.shape({
    created: PropTypes.string,
    modified: PropTypes.string,
    effective: PropTypes.string,
  }),
};

export default Body;
